function debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

if(!customElements.get('cre-quantity-sync')) {
  customElements.define(
    'cre-quantity-sync',
    class CreProductForm extends HTMLElement {
      constructor() {
        super();

        this.inputTracker = this.querySelector('input[type=number]');
        this.productQty = +this.getAttribute('data-initial-cart-qty');
        this.productVariantId = this.getAttribute('data-vid');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cartUpdateUnsubscriber = undefined;

        this.qtyBtnMinus = this.querySelector('.qty-btn-minus');
        this.qtyBtnPlus = this.querySelector('.qty-btn-plus');
        this.bindUIElements();
        this.debouncedUpdateCart = debounce(() => {
          console.log('remote update cart...', this.productQty);

          this.toggleQtySyncState(true);

          this.submitUpdate();
        }, 400);
      }

      toggleQtySyncState(disable) {

        if(disable) {
          this.qtyBtnMinus.setAttribute('disabled', true);
          this.qtyBtnPlus.setAttribute('disabled', true);
        } else {
          this.qtyBtnMinus.removeAttribute('disabled');
          this.qtyBtnPlus.removeAttribute('disabled');
        }
      }


      onProductQtyMinus(e) {
        e.preventDefault();

        if(this.productQty == 0) {
          this.productQty = 0;
        } else {
          this.productQty = this.productQty - 1;
        }

        this.inputTracker.value = this.productQty;

        this.debouncedUpdateCart();

        console.log('cdebug', 'minus', this.productQty);
      }

      onProductQtyPlus(e) {
        e.preventDefault();

        this.productQty = this.productQty + 1;

        this.inputTracker.value = this.productQty;

        this.debouncedUpdateCart();

        console.log('cdebug', 'plus', this.productQty);
      }

      bindUIElements() {
        this.qtyBtnMinus.addEventListener('click', this.onProductQtyMinus.bind(this));
        this.qtyBtnPlus.addEventListener('click', this.onProductQtyPlus.bind(this));
      }

      toggleElementVisibility(show) {
        if(!show) {
          this.classList.add('hidden');
        } else {
          this.classList.remove('hidden');
        }
      }

      onCartUpdate(e) {
        // If cart is being cleared, reset this element
        if(e?.source == 'clear-cart') {
          this.productQty = 0;
          this.inputTracker.value = this.productQty;
          this.toggleElementVisibility();
        }

        const incomingVariantId = e?.productVariantId;
        const incomingQty = +e?.incomingQty;

        console.log('cdebug quantity sync cart update', e);

        if(incomingVariantId == this.productVariantId) {
          this.productQty = incomingQty;
          this.inputTracker.value = this.productQty;


          // Toggle visibility
          if(incomingQty == 0) {
            this.toggleElementVisibility();
          } else {
            this.toggleElementVisibility(true);
          }
        }

      }

      connectedCallback() {
        // Declare subscriber for updates to cart
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          this.onCartUpdate(event);
        });
      }

      disconnectedCallback() {
        // Declare subscriber for updates to cart
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }


      async submitUpdate() {
        let variantId = this.productVariantId;
        let incomingQty = this.productQty;

        console.log('cdebug submitting update...', variantId, incomingQty);

        let formData = {
          'id': variantId,
          'quantity': this.productQty,
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        };

        let response;
        let responseStatus;

        try {
          response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            responseStatus = response.status;

            console.log('cdebug', response)

            return response.json();
          });

        } catch(e) {
          console.error('cdebug error', e);
          console.log('cdebug error details', e);
        }

        console.log('cdebug', response, responseStatus)

        // If response is 200, then successful request
        if(responseStatus == 200) {
          publish(PUB_SUB_EVENTS.cartUpdate,
                    {
                      source: 'cre-quantity-sync',
                      productVariantId: variantId,
                      sectionUpdates: response.sections,
                      incomingQty: incomingQty,
                    });

          // Add to cart always triggers cart update
          // Where the visual response is to show the toast
          // as a sign that add to cart was successful
          this.cart.renderContents(response, true, 'cre-quantity-sync');
        }


        this.toggleQtySyncState(false);

      }
    }
  )
}
